import { render } from "./SubiektProduction.vue?vue&type=template&id=61fa767c&scoped=true"
import script from "./SubiektProduction.vue?vue&type=script&lang=js"
export * from "./SubiektProduction.vue?vue&type=script&lang=js"

import "./SubiektProduction.vue?vue&type=style&index=0&id=61fa767c&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fa767c"]])

export default __exports__